import { createSelector } from '@ngrx/store';

import { loylatyProductProgramsState } from '../root';

export const hasRequestedLoyaltyProductPrograms = createSelector(loylatyProductProgramsState, (loyaltyProductPrograms) => loyaltyProductPrograms.data?.length > 0);
